var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9734",
    "data-name": "Group 9734",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.003,
    height: 31,
    viewBox: "0 0 31.003 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3353",
    "data-name": "Rectangle 3353",
    width: 31.003,
    height: 31,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4837",
    "data-name": "Group 4837",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32270",
    "data-name": "Path 32270",
    d: "M.059,87.55c-.028.18.069.374-.059.543v-.545q.031-.041.059,0",
    transform: "translate(0 -80.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32271",
    "data-name": "Path 32271",
    d: "M.059,83.372,0,83.37v-.363c.109.107.042.243.059.365",
    transform: "translate(0 -76.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32272",
    "data-name": "Path 32272",
    d: "M0,75.824c.078.04.065.081,0,.121Z",
    transform: "translate(0 -70.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32273",
    "data-name": "Path 32273",
    d: "M235.123,63.9c0,.121,0,.242,0,.363a.513.513,0,0,1-.5.565.522.522,0,0,1-.535-.537,10.641,10.641,0,0,0-.178-1.681,8.671,8.671,0,0,0-3.132-5.149,8.523,8.523,0,0,0-3.673-1.731,8.252,8.252,0,0,0-1.557-.177c-.526-.008-.774-.215-.747-.578s.3-.5.825-.478a9.866,9.866,0,0,1,8.876,6.374,8.505,8.505,0,0,1,.424,1.473,8.287,8.287,0,0,1,.2,1.557",
    transform: "translate(-207.747 -50.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32274",
    "data-name": "Path 32274",
    d: "M225.689,95.263a6.708,6.708,0,0,1,6.179,5.289,5.489,5.489,0,0,1,.143,1.348.525.525,0,0,1-.49.575.514.514,0,0,1-.541-.555,5.711,5.711,0,0,0-1.226-3.461,5.544,5.544,0,0,0-4.21-2.159c-.52-.025-.78-.206-.76-.568.019-.329.321-.582.815-.477a.672.672,0,0,0,.09.007",
    transform: "translate(-207.731 -88.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32275",
    "data-name": "Path 32275",
    d: "M225.556,136.275a3.617,3.617,0,0,1,3.407,3.5.567.567,0,0,1-.311.572.486.486,0,0,1-.538-.069.536.536,0,0,1-.2-.423,2.694,2.694,0,0,0-.6-1.607,2.579,2.579,0,0,0-1.917-.94.525.525,0,0,1-.557-.41.486.486,0,0,1,.24-.565.777.777,0,0,1,.47-.059",
    transform: "translate(-207.774 -125.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32276",
    "data-name": "Path 32276",
    d: "M30.07,23.83q-3.025-2.024-6.057-4.035a1.837,1.837,0,0,0-2.64.436c-.564.723-1.124,1.45-1.691,2.171a.783.783,0,0,1-1.116.241A20.553,20.553,0,0,1,16.6,21.47a32.552,32.552,0,0,1-4.76-4.284A19.839,19.839,0,0,1,8.394,12.5a.831.831,0,0,1,.263-1.231c.675-.528,1.353-1.052,2.027-1.58a1.875,1.875,0,0,0,.448-2.821c-1.269-1.9-2.548-3.795-3.8-5.706A2.446,2.446,0,0,0,5.873,0H5.267A2.086,2.086,0,0,0,4.61.18C3.662.752,2.7,1.3,1.77,1.9A3.753,3.753,0,0,0,.2,4.146c-.119.429-.114.871-.2,1.3v.3a.079.079,0,0,1,0,.121V6.3c.066.122.015.253.031.379A1.906,1.906,0,0,1,0,7.2v.182a.091.091,0,0,1,.058.094A10.986,10.986,0,0,0,.523,9.874a21.38,21.38,0,0,0,3.24,6.366,49.532,49.532,0,0,0,9.227,9.667,26.413,26.413,0,0,0,6.315,3.915A12.334,12.334,0,0,0,26.1,30.879a4.064,4.064,0,0,0,3.152-2.02c.45-.8.944-1.568,1.413-2.354a1.84,1.84,0,0,0-.6-2.675m-.35,2.216c-.43.716-.884,1.418-1.284,2.15a3.1,3.1,0,0,1-2.454,1.644,8.63,8.63,0,0,1-1.846.108,13.324,13.324,0,0,1-5.268-1.465,32.283,32.283,0,0,1-7.748-5.57A47.3,47.3,0,0,1,4.7,15.767a21.391,21.391,0,0,1-3.041-5.729,10.009,10.009,0,0,1-.4-5.5A2.766,2.766,0,0,1,2.556,2.726Q3.832,1.95,5.117,1.189a.79.79,0,0,1,1.133.253q2.058,3.074,4.1,6.158a.79.79,0,0,1-.212,1.189c-.694.552-1.4,1.093-2.1,1.635a1.876,1.876,0,0,0-.547,2.63,24.19,24.19,0,0,0,4.674,5.975,25.7,25.7,0,0,0,4.452,3.71c.452.281.919.539,1.386.8A1.835,1.835,0,0,0,20.54,23q.781-1,1.558-2.006c.481-.62.813-.677,1.457-.247l5.854,3.9a.869.869,0,0,1,.31,1.395",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.e6872a234e69095493e07dbba2d528ca.svg";
export { ForwardRef as ReactComponent };